import { HttpContextToken } from "@angular/common/http";

export const IS_IN_RESOLVER_CONTEXT = new HttpContextToken<boolean>(
  () => false,
);
